module.exports = __webpack_public_path__ + "static/img/superhero_04.505efe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/pic/superhero_04.png
// module id = Mkn+
// module chunks = 0